import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, StackItem } from '@optimus-web/core';
import { WithEnterpriseIds } from '../../../../../types';
import { CommonFields } from './CommonFields';
import { ABSOLUTE_ADJUSTMENT_FIELD_NAME, RELATIVE_ADJUSTMENT_FIELD_NAME } from './fieldNames';
import { LockableRateInputField } from './LockableFields';
import { FieldName, WithFieldsConfig } from './types';
import { RateBaseRateField } from './RateBaseRateField';

type DependentRateFieldsProps = WithEnterpriseIds &
    WithFieldsConfig & {
        selectedRateIds?: string[];
        unlockField?: (fieldName: FieldName) => void;
    };

export const DependentRateFields = ({
    enterpriseIds,
    fieldsConfig,
    selectedRateIds,
    unlockField,
}: DependentRateFieldsProps) => (
    <CommonFields
        unlockField={unlockField}
        selectedRateIds={selectedRateIds}
        enterpriseIds={enterpriseIds}
        fieldsConfig={fieldsConfig}
        isDependentRate
    >
        <RateBaseRateField enterpriseIds={enterpriseIds} fieldsConfig={fieldsConfig} />
        <Stack itemAlignment="end" distribution="space-between" spacing="100" alignment="center">
            <StackItem grow>
                <LockableRateInputField
                    name={ABSOLUTE_ADJUSTMENT_FIELD_NAME}
                    fieldsConfig={fieldsConfig}
                    label={<LocalizedText textKey={TextKey.AbsoluteAdjustment} />}
                    onUnlock={() => (unlockField ? unlockField(ABSOLUTE_ADJUSTMENT_FIELD_NAME) : null)}
                    required
                />
            </StackItem>
            <StackItem grow>
                <LockableRateInputField
                    name={RELATIVE_ADJUSTMENT_FIELD_NAME}
                    label={<LocalizedText textKey={TextKey.RelativeAdjustment} />}
                    suffix={UnicodeEntity.Percent}
                    fieldsConfig={fieldsConfig}
                    onUnlock={() => (unlockField ? unlockField(RELATIVE_ADJUSTMENT_FIELD_NAME) : null)}
                    required
                />
            </StackItem>
        </Stack>
    </CommonFields>
);
